import { render, staticRenderFns } from "./ChatOrderProfileModalFormAddress.vue?vue&type=template&id=f9610238&scoped=true&"
import script from "./ChatOrderProfileModalFormAddress.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileModalFormAddress.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileModalFormAddress.vue?vue&type=style&index=0&id=f9610238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9610238",
  null
  
)

export default component.exports